import { cn } from '@/lib/utils/cn';

interface AreaDotProps {
  color: string;
  size?: 'sm' | 'md';
  className?: string;
  /**
   * Name des Bereichs - steht dann auch als Text da (Tooltip und fuer
   * Screenreader bzw. Claude in der Seitenleiste, F-21), nicht nur als Farbe.
   */
  name?: string;
}

/**
 * Bereichsfarbe als Punkt.
 *
 * Die Farbe kommt als Inline-Custom-Property, weil Tailwind keine Klassen aus
 * Laufzeitwerten erzeugen kann.
 */
export function AreaDot({ color, size = 'md', className, name }: AreaDotProps) {
  const punkt = (
    <span
      aria-hidden="true"
      title={name ? `Bereich: ${name}` : undefined}
      data-area
      style={{ '--area': color } as React.CSSProperties}
      className={cn(
        'area-dot inline-block shrink-0 rounded-full',
        size === 'sm' ? 'size-2' : 'size-2.5',
        className,
      )}
    />
  );
  if (!name) return punkt;
  return <>{punkt}<span className="sr-only">Bereich: {name}</span></>;
}
